import initArchiveFilters from './components/archive-filters';
import initCardsLists from './components/cards-list';
import initCaseStudiesList from './components/case-studies-list';
import initCollapsibles from './components/collapsible';
import initCounters from './components/counter';
import initFocusables from './components/focusable';
import initInvisibleLinks from './components/invisible-link';
import initModals from './components/modal';
import initPostsCarousel from './components/posts-carousel';
import initSliderCardsWithIcon from './components/slider-cards-with-icon';
import initSliderLogos from './components/slider-logos';
import initStickyBackground from './components/sticky-background';
import initStickyElements from './components/sticky-element';
import initTabs from './components/tabs';
import initTestimonials from './components/testimonials';
import initYoutubePlayers from './components/youtube-player';
import initHeader from './modules/header';
import initPreHeader from './modules/pre-header';
import DeviceManager from './utils/device-manager';

// Fix height on iOs devices
const appHeight = () => {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);

initPreHeader();
initHeader();
initTabs();
initStickyBackground();
initStickyElements();
initCardsLists();
initInvisibleLinks();
initTestimonials();
initCaseStudiesList();
initCollapsibles();
initFocusables();
initArchiveFilters();
initPostsCarousel();
initSliderLogos();
initModals();
initYoutubePlayers();
initCounters();
initSliderCardsWithIcon();

// Always call after all other files
DeviceManager.init();
